// extracted by mini-css-extract-plugin
export var border = "_g-7";
export var brand = "_g-r";
export var button = "_g-j";
export var center = "_g-9";
export var centered = "_g-5";
export var closeButton = "_g-b";
export var disabledWrapper = "_g-k";
export var error = "_g-n";
export var extraLarge = "_g-4";
export var extraSmall = "_g-1";
export var fill = "_g-g";
export var footer = "_g-f";
export var footerAction = "_g-h";
export var footerButtons = "_g-i";
export var header = "_g-6";
export var icon = "_g-m";
export var info = "_g-q";
export var inline = "_g-8";
export var large = "_g-3";
export var main = "_g-c";
export var modal = "_g-0";
export var neutral = "_g-s";
export var noPadding = "_g-e";
export var none = "_g-t";
export var scrollable = "_g-d";
export var small = "_g-2";
export var success = "_g-p";
export var tight = "_g-l";
export var titleIcon = "_g-a";
export var warn = "_g-o";